export default [

  
  {
    name: 'Customers',
    icon: 'ti-user',
    children: [
      {
        name: 'List',
        path: '/customer/list'
      }
    ]
  },
  {
    name: 'Partners',
    icon: 'ti-user',
    children: [
      {
        name: 'List',
        path: '/home'
      }
    ]
  }
  
 

]



// WEBPACK FOOTER //
// ./src/sidebarLinks.js